import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
// import illustration from "../../../assets/illustration.png";
import feeling_driven from "../../../assets/feeling_driven.png";
// import feeling_anxious from "../../../assets/feeling_anxious.png";
import feeling_sad from "../../../assets/feeling_sad.png";
// import star_award from "../../../assets/star-award.png";

const CelebrationPage = ({ newSession, useCase, sessionStoryId }) => {
  const navigate = useNavigate();
  const [countdown, setCountdown] = useState(5);
  const apiBaseURL = process.env.REACT_APP_BACKEND_API_URL;

  // Define content based on use case
  const getContentByUseCase = (caseType) => {
    switch (caseType) {
      // I didn't find this session helpful
      case "not_helpful":
        return {
          title: "You didn't find this session helpful and that's okay.",
          message: (
            <>
              <p className="text-[#323232]">
                Many who felt the same found surprising clarity in what came
                next, a{" "}
                <span className="text-[#54B0AF]">clarity blueprint.</span>{" "}
              </p>

              <p className="mt-4 text-[#323232]">
                It holds your{" "}
                <span className="text-[#54B0AF]">blind spots</span> and{" "}
                <span className="text-[#54B0AF]">unspoken struggles</span> that
                have surfaced.
              </p>
              <p className="mt-4 text-[#323232]">
                They found their next steps here, you can too.
                {"\n"}
              </p>
            </>
          ),
          inboxTitle: "Look out for an email in your inbox",
          inboxMessage: <>It includes your insights and next steps.</>,
          countdownDuration: 15,
          illustration: feeling_sad,
        };

      // I feel empowered
      case "finished_strong":
        return {
          title: "You finished strong, and feeling empowered!",
          message: (
            <>
              Your clarity blueprint is taking shape.
              <br />
              <p className="mt-4 text-[#323232]">
                It holds your{" "}
                <span className="text-[#54B0AF]">blind spots</span> and{" "}
                <span className="text-[#54B0AF]">unspoken struggles</span> that
                have surfaced now and
                <span className="text-[#54B0AF]">
                  {" "}
                  waiting to be untangled.
                </span>
              </p>
              <p className="mt-4 text-[#323232]">
                Let’s continue untangling your knot once you are back!
                {"\n"}
              </p>
            </>
          ),

          inboxTitle: "Look out for an email in your inbox",
          inboxMessage: <>It includes your insights and next steps. </>,
          countdownDuration: 15,
          illustration: feeling_driven,
        };

      // Condition - User completes the session after Actions Pop up
      case "after_actions_popup":
      default:
        return {
          title: "You finished strong, and feeling empowered!",
          message: (
            <>
              Your clarity blueprint is taking shape.
              <br />
              <p className="mt-4 text-[#323232]">
                It holds your{" "}
                <span className="text-[#54B0AF]">blind spots</span> and{" "}
                <span className="text-[#54B0AF]">unspoken struggles</span> that
                have surfaced now and
                <span className="text-[#54B0AF]">
                  {" "}
                  waiting to be untangled.
                </span>
              </p>
              <p className="mt-4 text-[#323232]">
                Let’s continue untangling your knot once you are back!
                {"\n"}
              </p>
            </>
          ),

          inboxTitle: "Look out for an email in your inbox",
          inboxMessage: (
            <>
              It includes your insights and next steps.{" "}
              {/* <span className="text-[#54B0AF]">
                you'll receive a clarity blueprint soon
              </span> */}
            </>
          ),
          countdownDuration: 15,
          illustration: feeling_driven,
        };
    }
  };

  const content = getContentByUseCase(useCase);

  useEffect(() => {
    setCountdown(content.countdownDuration);

    let timer;
    if (content.countdownDuration > 0) {
      timer = setInterval(() => {
        setCountdown((prev) => {
          if (prev <= 1) {
            clearInterval(timer);
            return 0;
          }
          return prev - 1;
        });
      }, 1000);
    }

    const redirectTimer = setTimeout(() => {
      console.log("this is the story id", sessionStoryId);
      // navigate(`/workspace?story_id=${sessionStoryId}`);
      navigate(`/workspace?story_id=${sessionStoryId.identity_reflection_id}`);
    }, 15000);

    return () => {
      clearInterval(timer);
      clearTimeout(redirectTimer);
    };
  }, [navigate, content.countdownDuration, sessionStoryId]);

  useEffect(() => {
    const endSession = async () => {
      try {
        const res = await fetch(
          `${apiBaseURL}/users/session/${newSession}/end`,
          {
            method: "PUT",
            headers: {
              "Content-Type": "application/json",
            },
          }
        );

        const exitSession = await res.json();
        console.log(exitSession);
        console.log("session Ended");
      } catch (error) {
        console.log("The session has ended:", error.message);
      }
    };

    endSession();
  }, [apiBaseURL, newSession]);

  return (
    <>
      <div className="fixed inset-0 bg-gray-700 bg-opacity-80 z-50 flex items-center justify-center font-gotham px-4">
        <div className="bg-white rounded-2xl shadow-lg w-full max-w-[650px] h-auto text-center p-4 md:p-6">
          <div className="relative flex justify-center my-4 md:my-4">
            <motion.img
              src={content.illustration}
              alt="Illustration"
              className="w-24 md:w-60 h-28 md:h-60 relative"
            />
          </div>
          <div className="text-center px-2 md:px-4">
            <h1 className="text-2xl md:text-3xl font-medium font-gotham text-[#323232] mb-4 md:mb-3">
              {content.title}
            </h1>
            <div className="text-[#323232] font-gotham text-base md:text-lg leading-snug whitespace-pre-line">
              {content.message}
            </div>

            {content.inboxTitle && (
              <div className="mt-3 md:mt-4">
                <h2 className="text-xl md:text-2xl font-bold text-[#54B0AF] font-gotham mb-3">
                  {content.inboxTitle}
                </h2>
                <p className="text-[#323232] font-gotham text-base md:text-xl leading-snug">
                  {content.inboxMessage}
                </p>
              </div>
            )}
          </div>
          <p className="text-[#54B0AF] font-gotham font-bold mt-3 md:mt-5 text-base md:text-xl">
            <span className="text-[#323232] ">
              If you’d rather continue right now, you can find <br /> everything
              at
            </span>{" "}
            Your Space in {countdown}s
          </p>
        </div>
      </div>
    </>
  );
};

export default CelebrationPage;

// before 24-07-2025 (06:00 PM)

// import { useEffect, useState } from "react";
// import { useNavigate } from "react-router-dom";
// import { motion } from "framer-motion";
// import illustration from "../../../assets/illustration.png";
// import star_award from "../../../assets/star-award.png";
// import Feedback from "./Feedback";

// const CelebrationPage = ({ newSession }) => {
//   const navigate = useNavigate();
//   const [countdown, setCountdown] = useState(5);
//   const [showFeedback, setShowFeedback] = useState(false);

//   useEffect(() => {
//     const timer = setInterval(() => {
//       setCountdown((prev) => prev - 1);
//     }, 1000);

//     const redirectTimer = setTimeout(() => {
//       setShowFeedback(true);
//     }, 5000);

//     return () => {
//       clearInterval(timer);
//       clearTimeout(redirectTimer);
//     };
//   }, [navigate]);

//   return (
//     <>
//       {showFeedback ? (
//         <Feedback newSession={newSession} />
//       ) : (
//         <div className="fixed inset-0 bg-gray-700 bg-opacity-80 z-50 flex items-center justify-center font-gotham px-4">
//           <div className="bg-white rounded-2xl shadow-lg w-full max-w-[650px] h-auto text-center p-4 md:p-6">
//             <div className="relative flex justify-center my-6 md:my-8">
//               <motion.img
//                 src={illustration}
//                 alt="Illustration"
//                 className="w-48 md:w-72 absolute opacity-100"
//               />
//               <motion.img
//                 src={star_award}
//                 alt="Star Award"
//                 className="w-24 md:w-36 relative"
//               />
//             </div>
//             <div className="text-center px-2 md:px-8">
//               <h1 className="text-2xl md:text-3xl font-medium text-gray-800 mb-4 md:mb-6">
//                 Congratulations!
//               </h1>
//               <p className="text-gray-700 text-base md:text-lg leading-relaxed ">
//                 Your session is successfully completed, and we couldn't be
//                 happier for you!{" "}
//                 <strong className="font-semibold">Thank you</strong> for being
//                 part of this journey. We appreciate you and can't wait to see
//                 you again soon!
//               </p>
//             </div>
//             <p className="text-gray-700 mt-4 md:mt-5 text-sm md:text-base">
//               Returning to Dashboard in {countdown}s
//             </p>
//           </div>
//         </div>
//       )}
//     </>
//   );
// };

// export default CelebrationPage;
